// src/components/ui/PageHeader.js
import React from "react";

// 画面上部の見出し。左にタイトル+サブテキスト、右にアクション。
function PageHeader({ title, subtitle, actions }) {
  return (
    <header
      style={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: 16,
        marginBottom: 24,
      }}
    >
      <div>
        <h1 style={{ fontSize: 20 }}>{title}</h1>
        {subtitle && (
          <p
            style={{
              margin: "4px 0 0",
              fontSize: 13,
              color: "var(--text-tertiary)",
            }}
          >
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>{actions}</div>
      )}
    </header>
  );
}

export default PageHeader;
